{
  "error.unauthenticated": "Du må logge inn for å fortsette.",
  "error.forbidden": "Du har ikke tilgang til dette.",
  "error.not_found": "Vi fant ikke det du lette etter.",
  "error.rate_limited": "For mange forsøk. Vent litt og prøv igjen.",
  "error.token_invalid": "Lenken virker ikke. Be om en ny fra bekreftelsesmailen.",
  "error.token_expired": "Lenken har gått ut. Be om en ny fra bekreftelsesmailen.",
  "error.token_already_used": "Lenken er allerede brukt.",
  "error.validation_failed": "Noe i skjemaet ser ikke riktig ut.",
  "error.internal": "Noe gikk galt hos oss. Prøv igjen om litt.",
  "error.slot_unavailable": "Tiden er dessverre ikke ledig lenger. Velg en annen tid nedenfor.",
  "error.hold_expired": "Reservasjonen din gikk ut. Velg tiden igjen, så holder vi den i ti minutter.",
  "error.outside_booking_window": "Den tiden kan ikke bestilles. Velg en tid lenger fram.",
  "error.too_late_to_cancel": "Det er for sent å endre bestillingen selv. Ring verkstedet, så ordner vi det.",
  "error.invalid_status_transition": "Bestillingen kan ikke bytte til den statusen.",
  "error.service_unavailable": "Den tjenesten tilbys ikke på dette verkstedet.",
  "error.no_resource_available": "Ingen er ledig for den jobben akkurat da. Velg en annen tid.",
  "error.outside_service_area": "Adressen ligger utenfor verkstedets område.",
  "error.daily_limit_reached": "Verkstedet er fullbooket den dagen. Velg en annen dag.",
  "error.idempotency_key_reused": "Forespørselen ble sendt på nytt med et annet innhold.",
  "error.storage_unavailable": "Bildeopplasting er ikke i gang her. Ta kontakt med support.",
  "error.integration_unavailable": "Google Kalender er ikke i gang her. Ta kontakt med support.",
  "error.integration_handshake_failed": "Koblingen til Google ble avbrutt. Prøv å koble til på nytt.",
  "error.resource_in_use": "Det finnes kommende bestillinger igjen. Flytt dem over først.",
  "error.product_unavailable": "Ett eller flere produkter kan ikke bestilles akkurat nå.",
  "error.workshop_paused": "Verkstedet er satt på pause og kan ikke bestille nå.",
  "error.address_incomplete": "Leveringsadressen mangler gateadresse eller postnummer.",
  "error.outside_working_hours": "Jobben får ikke plass i arbeidstiden fra det starttidspunktet.",
  "error.email_taken": "E-postadressen brukes allerede av en annen konto.",
  "error.shared_account": "Personen jobber også på et annet verksted. Kontakt HQ for å endre kontoen.",
  "error.owner_exists": "Verkstedet har allerede en aktiv eier."
}
